import {
  OUTLINE_SECTION_STATUS,
  OUTLINE_SECTION_STATUS_LABELS,
} from "constants/proposals";
import { modalTypes } from "constants/types";
import { useDispatch, useSelector } from "react-redux";
import { hideModal, showModal } from "slices/app/actions/modals";
import { updateSectionStatus } from "slices/proposalOutline/actions/outlineActions";
import { selectProposalOutlineSections } from "slices/proposalOutline/selectors";

import { getSubsectionIds } from "../outlineHelpers";

const useStatusCascade = (sectionId) => {
  const dispatch = useDispatch();
  const sections = useSelector(selectProposalOutlineSections);

  const promptCascadeDecision = (modalProps) =>
    new Promise((resolve) => {
      const close = () => dispatch(hideModal(modalTypes.CASCADE_STATUS_MODAL));
      dispatch(
        showModal(modalTypes.CASCADE_STATUS_MODAL, {
          ...modalProps,
          onConfirm: (cascade) => {
            close();
            resolve({ proceed: true, cascade });
          },
          onCancel: () => {
            close();
            resolve({ proceed: false, cascade: false });
          },
        })
      );
    });

  const onStatusChange = async (ownerType, ownerId, status) => {
    const subsectionIds = getSubsectionIds(sections, sectionId);

    if (subsectionIds.length === 0) {
      dispatch(updateSectionStatus(ownerType, ownerId, sectionId, status));
      return;
    }

    const subsections = sections.filter((section) =>
      subsectionIds.includes(section.id)
    );
    // Not Started counts as no status, so a sub-section left there isn't "already set".
    const secondaryCount = subsections.filter(
      (section) =>
        section.status && section.status !== OUTLINE_SECTION_STATUS.NOT_STARTED
    ).length;

    const { proceed, cascade } = await promptCascadeDecision({
      statusLabel: OUTLINE_SECTION_STATUS_LABELS[status],
      subsectionCount: subsectionIds.length,
      secondaryCount,
    });

    if (!proceed) {
      return;
    }

    dispatch(
      updateSectionStatus(
        ownerType,
        ownerId,
        sectionId,
        status,
        cascade ? subsectionIds : []
      )
    );
  };

  return { onStatusChange };
};

export default useStatusCascade;
